// Debug helper function
function logDebug(message) {
  console.log(`[Custom Collection] ${message}`);
}

document.addEventListener('DOMContentLoaded', function() {
  logDebug('Script loaded');
  
  // Find all custom sliders on the page
  const sliders = document.querySelectorAll('.custom-slider');
  logDebug(`Found ${sliders.length} sliders`);
  
  sliders.forEach((slider, index) => {
    const sliderId = slider.id;
    logDebug(`Initializing slider #${index + 1} with ID: ${sliderId}`);
    
    const sliderContainer = slider.closest('.custom-featured-collection__slider-container');
    
    if (sliderContainer) {
      const slides = slider.querySelectorAll('.custom-slider__slide');
      const prevButton = sliderContainer.querySelector('.custom-nav-button--prev');
      const nextButton = sliderContainer.querySelector('.custom-nav-button--next');
      
      logDebug(`Found ${slides.length} slides`);
      logDebug(`Previous button found: ${!!prevButton}`);
      logDebug(`Next button found: ${!!nextButton}`);
      
      if (slides.length > 0 && prevButton && nextButton) {
        // Direct event listeners - more reliable
        prevButton.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          logDebug('Previous button clicked');
          
          const slideWidth = slides[0].offsetWidth + 20; // Recalculate in case of resize
          logDebug(`Scrolling by -${slideWidth}px`);
          
          slider.scrollBy({
            left: -slideWidth,
            behavior: 'smooth'
          });
          
          setTimeout(updateButtonVisibility, 300);
          return false;
        };
        
        nextButton.onclick = function(e) {
          e.preventDefault();
          e.stopPropagation();
          logDebug('Next button clicked');
          
          const slideWidth = slides[0].offsetWidth + 20; // Recalculate in case of resize
          logDebug(`Scrolling by ${slideWidth}px`);
          
          slider.scrollBy({
            left: slideWidth,
            behavior: 'smooth'
          });
          
          setTimeout(updateButtonVisibility, 300);
          return false;
        };
        
        // Update button visibility function
        function updateButtonVisibility() {
          const isAtStart = slider.scrollLeft <= 10;
          const isAtEnd = (slider.scrollLeft + slider.clientWidth) >= (slider.scrollWidth - 10);
          
          logDebug(`Button visibility - isAtStart: ${isAtStart}, isAtEnd: ${isAtEnd}`);
          
          prevButton.disabled = isAtStart;
          nextButton.disabled = isAtEnd;
          
          // Even when hover effects are active, we want to respect the disabled state
          prevButton.style.opacity = isAtStart ? '0.5' : '';
          nextButton.style.opacity = isAtEnd ? '0.5' : '';
        }
        
        // Initialize button visibility
        updateButtonVisibility();
        
        // Mouse drag scrolling
        let isDown = false;
        let startX;
        let scrollLeft;
        
        // Mouse events for drag scrolling
        slider.addEventListener('mousedown', function(e) {
          isDown = true;
          slider.classList.add('grabbing');
          slider.style.cursor = 'grabbing';
          slider.style.scrollBehavior = 'auto';
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
          e.preventDefault(); // Prevent text selection
        });
        
        slider.addEventListener('mouseleave', function() {
          if (isDown) {
            isDown = false;
            slider.classList.remove('grabbing');
            slider.style.cursor = 'grab';
            slider.style.scrollBehavior = 'smooth';
          }
        });
        
        slider.addEventListener('mouseup', function() {
          if (isDown) {
            isDown = false;
            slider.classList.remove('grabbing');
            slider.style.cursor = 'grab';
            slider.style.scrollBehavior = 'smooth';
            updateButtonVisibility();
          }
        });
        
        slider.addEventListener('mousemove', function(e) {
          if (!isDown) return;
          const x = e.pageX - slider.offsetLeft;
          const walk = (x - startX) * 2; // Scroll speed multiplier
          slider.scrollLeft = scrollLeft - walk;
          updateButtonVisibility();
        });
        
        // Update button visibility on scroll
        slider.addEventListener('scroll', updateButtonVisibility);
        
        // Update on window resize
        window.addEventListener('resize', function() {
          updateButtonVisibility();
        });
      }
    }
  });
  
  // Add a global click handler for buttons as a fallback
  document.addEventListener('click', function(e) {
    if (e.target.closest('.custom-nav-button--prev')) {
      logDebug('Global click handler - prev button');
      const button = e.target.closest('.custom-nav-button--prev');
      const container = button.closest('.custom-featured-collection__slider-container');
      if (container) {
        const slider = container.querySelector('.custom-slider');
        if (slider) {
          const slides = slider.querySelectorAll('.custom-slider__slide');
          if (slides.length > 0) {
            const slideWidth = slides[0].offsetWidth + 20;
            slider.scrollBy({
              left: -slideWidth,
              behavior: 'smooth'
            });
          }
        }
      }
    }
    else if (e.target.closest('.custom-nav-button--next')) {
      logDebug('Global click handler - next button');
      const button = e.target.closest('.custom-nav-button--next');
      const container = button.closest('.custom-featured-collection__slider-container');
      if (container) {
        const slider = container.querySelector('.custom-slider');
        if (slider) {
          const slides = slider.querySelectorAll('.custom-slider__slide');
          if (slides.length > 0) {
            const slideWidth = slides[0].offsetWidth + 20;
            slider.scrollBy({
              left: slideWidth,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  });
});
